var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_161_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7222 3.47222H3.27778C3.13542 3.47222 2.99514 3.48264 2.85834 3.50347L2.85556 4.72153L0.959725 4.71875C0.659133 5.1728 0.499214 5.70546 0.500003 6.25V18.75C0.500003 19.4867 0.792661 20.1932 1.3136 20.7142C1.83453 21.2351 2.54107 21.5278 3.27778 21.5278H22.7222C23.4589 21.5278 24.1655 21.2351 24.6864 20.7142C25.2073 20.1932 25.5 19.4867 25.5 18.75V6.25C25.5 5.51329 25.2073 4.80675 24.6864 4.28581C24.1655 3.76488 23.4589 3.47222 22.7222 3.47222Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7736 6.59722H19.8965L19.7618 6.19444L19.5972 5.70416L19.4326 6.19444L19.2979 6.59722H18.4208L18.7923 6.90486L19.1201 7.17569L18.9819 7.58333L18.7965 8.12638L19.2521 7.77638L19.5972 7.51041L19.9423 7.77638L20.3979 8.12638L20.2125 7.58333L20.0743 7.17569L20.4021 6.90486L20.7736 6.59722Z",
    fill: "#EEEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5972 6.25L19.4229 6.77083H18.9028L19.3229 7.11875L19.1458 7.63889L19.5972 7.29167L20.0486 7.63889L19.8715 7.11875L20.2917 6.77083H19.7715L19.5972 6.25Z",
    fill: "#CF1B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7736 17.8819H19.8965L19.7618 17.4792L19.5972 16.9889L19.4326 17.4792L19.2979 17.8819H18.4208L18.7923 18.1896L19.1201 18.4604L18.9819 18.8681L18.7965 19.4111L19.2521 19.0611L19.5972 18.7951L19.9423 19.0611L20.3979 19.4111L20.2125 18.8681L20.0743 18.4604L20.4021 18.1896L20.7736 17.8819Z",
    fill: "#EEEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5972 17.5347L19.4229 18.0556H18.9028L19.3229 18.4035L19.1458 18.9236L19.5972 18.5764L20.0486 18.9236L19.8715 18.4035L20.2917 18.0556H19.7715L19.5972 17.5347Z",
    fill: "#CF1B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5514 9.375H22.6743L22.5396 8.97222L22.375 8.48194L22.2104 8.97222L22.0757 9.375H21.1986L21.5702 9.68264L21.8979 9.95347L21.7597 10.3611L21.5743 10.9042L22.0299 10.5542L22.375 10.2882L22.7202 10.5542L23.1757 10.9042L22.9903 10.3611L22.8521 9.95347L23.1799 9.68264L23.5514 9.375Z",
    fill: "#EEEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.375 9.02778L22.2007 9.54861H21.6806L22.1007 9.89653L21.9236 10.4167L22.375 10.0694L22.8264 10.4167L22.6493 9.89653L23.0694 9.54861H22.5493L22.375 9.02778Z",
    fill: "#CF1B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9958 10.7639H17.1188L16.984 10.3611L16.8195 9.87083L16.6549 10.3611L16.5202 10.7639H15.6431L16.0146 11.0715L16.3424 11.3424L16.2042 11.75L16.0188 12.2931L16.4743 11.9431L16.8195 11.6771L17.1646 11.9431L17.6201 12.2931L17.4347 11.75L17.2965 11.3424L17.6243 11.0715L17.9958 10.7639Z",
    fill: "#EEEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8194 10.4167L16.6451 10.9375H16.125L16.5451 11.2854L16.3681 11.8056L16.8194 11.4583L17.2708 11.8056L17.0938 11.2854L17.5139 10.9375H16.9937L16.8194 10.4167Z",
    fill: "#CF1B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6944 12.5V3.47222H3.27778C3.05556 3.47222 2.85834 3.50347 2.85834 3.50347L2.85556 4.72153L0.959724 4.71875C0.959724 4.71875 0.930558 4.75972 0.87153 4.86111C0.627581 5.28329 0.499419 5.7624 0.500002 6.25V12.5H13.6944Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6944 3.47222H12.0757L8.83333 5.74236V3.47222H5.36111V5.25625L2.85833 3.50347C2.44087 3.56583 2.04348 3.72388 1.69722 3.96528L4.9625 6.25H3.75694L1.17153 4.43819C1.09528 4.52731 1.02455 4.62101 0.959722 4.71875L3.14792 6.25H0.5V9.72222H3.19792L0.5 11.6431V12.5H2.81389L5.36111 10.7167V12.5H8.83333V10.2299L12.075 12.5H13.6944V11.091L11.7396 9.72222H13.6944V6.25H11.7403L13.6944 4.88125V3.47222Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13889 3.47222H6.05556V6.94444H0.5V9.02778H6.05556V12.5H8.13889V9.02778H13.6944V6.94444H8.13889V3.47222Z",
    fill: "#CF1B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6944 3.47222H12.6799L8.83333 6.16597V6.25H9.9243L13.6944 3.60972V3.47222ZM1.69722 3.96528C1.5028 4.10018 1.32617 4.25908 1.17153 4.43819L3.75694 6.25H4.9618L1.69722 3.96528ZM4.97014 9.72222L1.00972 12.5H2.20903L5.36111 10.2931V9.72222H4.97014ZM13.6944 12.3625V11.5153L11.134 9.72222H9.92361L13.6944 12.3625Z",
    fill: "#CF1B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/NewZealand.c3bfde4962e8b54122a567137c119076.svg";
export { ForwardRef as ReactComponent };